import React, { useState, useEffect } from "react";
import { routes } from "../../router/paths";
import { Logo, Title } from "../../components/atoms";
import { LoginForm,ForgotPasswordForm } from "../../components/organisms";
import Actions from "../../store/actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { AnalyticsService } from "../../utils/Analytics";
import { useMediaQuery } from 'react-responsive';

const Login = (props) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [page, setPage] = useState(1);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })

  useEffect(() => {
    const authenticated = localStorage.getItem("isAuthenticated");
    if (authenticated === "true") {
      navigate(routes.dashboard);
    }
    
    
    AnalyticsService.logEvent("LOGIN_VIEW");
  }, []);

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
    if (password === "" && isSubmit === true) {     
      LoginPortal();
    }
  };
  const handleForgotPasswordClick = () =>{

    navigate(routes.forgotPassword);
  };

  const togglePassword = () => {
    setIsVisible(!isVisible);
  };

  const validateEmail = (emailAddress) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailAddress)) {
      return true;
    }
    return false;
  };

  const LoginPortal = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const { actions } = props;
    if (email !== "" && password !== "") {
      const response = await actions.login({
        Email: email,
        Password: password,
      });
      if (response && response.success === true) {
        var hasChangedPass = localStorage.getItem("hasChangedPassword");
        if(hasChangedPass == "false")
        {
          
          navigate(routes.changePassword);
        }
        else
        {

        
        navigate(routes.dashboard);
            localStorage.setItem("isAuthenticated", true);
            localStorage.setItem("roleId", response.data.roleId); // admin role id is 1
            localStorage.setItem("xSwitch", response.data.xSwitch);
            localStorage.setItem("id", response.data.id);
        navigate(0);
        setLoading(true);
        }

      } else {
        setError(
          response && response.message
            ? response.message
            : "Internal server error"
        );
        setLoading(false);
        AnalyticsService.logEvent("USER_LOG_IN_ERROR", {
          Error:
            response && response.message
              ? response.message
              : "Internal server error",
        });
      }
    } else {
      setError("");
    }
  };

  const ForgotPasswordAction = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const { actions } = props;
    if (email !== "" ) {
      const response = await actions.forgotPassword({
        Email: email,        
      });
      if (response && response.success === true) {
        alert("Reset email password sent successfully");
        navigate(routes.login);
        
      } else {
        setError(
          response && response.message
            ? response.message
            : "Internal server error"
        );
        setLoading(false);
        AnalyticsService.logEvent("USER_FORGOTPASSWORD_ERROR", {
          Error:
            response && response.message
              ? response.message
              : "Internal server error",
        });
      }
    } else {
      setError("");
    }
  };

  return (
    <div className="main">
      <div >
      {!isTabletOrMobile &&
        <div className="leftPanel center2 background1">
          <img width="300px" src={require('../../assets/images/logo.png')} alt="Logo image" />
          <div style={{color:"#FFF",letterSpacing:"1.62px",fontSize:"24px",marginTop:"30px",fontWeight:'600'}}>Portal</div>
        </div>}
        <div className="rightPanel center" style={{padding:isTabletOrMobile?'20px 40px':'20px 100px'}}  >
          <div className="center">
            {isTabletOrMobile && <Logo />}
            {page==1 
            ?
            <div>
              <div style={{color:'#000000',fontSize:'35px',fontWeight:'bold',marginTop:isTabletOrMobile?"0px":"120px"}}>WELCOME</div>
              <div style={{color:'#E3031F',fontSize:'21px',fontWeight:'bold',marginBottom:'50px'}}>HAVE A WICKET TIME!</div>
              <LoginForm
                LoginPortal={LoginPortal}
                onChangeEmail={onChangeEmail}
                onChangePassword={onChangePassword}
                email={email}
                password={password}
                isSubmit={isSubmit}
                validateEmail={validateEmail}
                errorMessage={error}
                togglePassword={togglePassword}
                isVisible={isVisible}
                isLoading={loading}
                changePage={setPage}
              />
            </div>
            :
            <div>
              <div style={{color:'#000000',fontSize:'35px',fontWeight:'bold',marginTop:isTabletOrMobile?"0px":"150px"}}>Reset Password</div>
              <div style={{color:'#E3031F',fontSize:'21px',fontWeight:'bold',marginBottom:'50px'}}>Enter your Email Address</div>
              
              <ForgotPasswordForm
                ForgotPasswordAction={ForgotPasswordAction}
                onChangeEmail={onChangeEmail}           
                email={email}           
                isSubmit={isSubmit}
                validateEmail={validateEmail}
                errorMessage={error}
                isLoading={loading}
                changePage={setPage}
              />
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(Login);
